const mapping: Record<string, string> = {
  id: 'l=>l.Id',
  name: 'p=>p.Name',
  serverId: 'p=>p.ServerId',
  address: 'p=>p.Address',
}

export const mapSortCameraServerParam = (key: string) => mapping[key]
